import React from 'react'
import nextapplogo from 'assets/images/NextapLogo.gif'

const PageLoader = () => {
    return <div className='d-flex h-100'>
        <div className='page-loader-container m-auto'>
            <div className='d-flex'>
                <img className='unlock-logo mx-auto' style={{ height: '150px', width: '150px' }} src={nextapplogo} alt='img' />
            </div>
            <div className='page-loader-text mt-1'>
                <span>Loading...</span>
            </div>
        </div>
    </div>
}

export default PageLoader